const FETCH_POSTING_STATISTICS = 'desempeno/performance/FETCH_POSTING_STATISTICS';
const FETCH_BEST_POSTING_STATISTICS = 'desempeno/performance/FETCH_BEST_POSTING_STATISTICS';
const FETCH_BEST_POSTING_STATISTICS_COMPLETED = 'desempeno/performance/FETCH_BEST_POSTING_STATISTICS_COMPLETED';
const FETCH_PRICE_STATISTICS = 'desempeno/performance/FETCH_PRICE_STATISTICS';
const FETCH_PERFORMANCE_STATUS = 'desempeno/performance/PERFORMANCE_STATUS';
const FETCH_PERFORMANCE_STATUS_COMPLETED = 'desempeno/performance/PERFORMANCE_STATUS_COMPLETED';
const FETCH_PERFORMANCE_STATUS_FAILED = 'desempeno/performance/PERFORMANCE_STATUS_FAILED';

export {
  FETCH_POSTING_STATISTICS,
  FETCH_PRICE_STATISTICS,
  FETCH_PERFORMANCE_STATUS,
  FETCH_PERFORMANCE_STATUS_COMPLETED,
  FETCH_PERFORMANCE_STATUS_FAILED,
  FETCH_BEST_POSTING_STATISTICS_COMPLETED,
  FETCH_BEST_POSTING_STATISTICS
};
